import { Button, Grid } from "@mui/material";
import TableData from "../../../components/Tables/TableData";
import { columnsApagar } from "../../../data/columnsFinanceiro";
import { useEffect, useState } from "react";
import CadApagar from "./Modals/CadApagar";
import SimpleBackdrop from "../../../components/Loading/SimpleBackdrop";
import { AlertInfo } from "../../../components/Alerts/Alert";
import { api } from "../../../services/api";
import moment from "moment";
import { ContasPagarType } from "../../../types/ContasPagarType";

export default function Apagar() {
    const [openLoad, setOpenLoad] = useState(false);
    const [rows, setRows] = useState<ContasPagarType[]>([]);
    const [openCad, setOpenCad] = useState(false);
    const [conta, setConta] = useState<ContasPagarType | null>(null);

    async function loadData() {
        setOpenLoad(true);
        try {
            const data = { start: moment().startOf('month').format("YYYY-MM-DD"), end: moment().endOf('month').format("YYYY-MM-DD") }
            const response = await api.post(`/listcontaspagar`, data);
            console.log(response);
            if (response.data.error) {
                AlertInfo({ icon: 'error', title: 'Falha na conexão' });
            } else {
                const res: ContasPagarType[] = response.data;
                const rowData = res.map((item, index) => ({...item, id: index}));
                setRows(rowData);
            }
            setOpenLoad(false);
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
            setOpenLoad(false);
        }
    }

    function handleEdit(row: ContasPagarType) {
        setConta(row);
        setOpenCad(true);
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <Grid container spacing={1} item xs={12}>
            <SimpleBackdrop open={openLoad} />
            <CadApagar
                open={openCad}
                setOpen={setOpenCad}
                conta={conta}
                setConta={setConta}
                reload={loadData}
            />
            <Grid item xs={12} sm={2}>
                <Button
                    variant="contained"
                    fullWidth
                    onClick={() => setOpenCad(true)}
                // onClick={() => {
                //     if (isPermite("10")) setOpenCadastroCliente(true);
                // }}
                >
                    NOVA CONTA
                </Button>
            </Grid>
            <Grid item xs={12}>
                <TableData
                    columns={columnsApagar}
                    rows={rows}
                    height={500}
                    handleClick={handleEdit}
                />
            </Grid>
        </Grid>
    );
}